// The preloader covers the page while it loads (see components/preloader.js). Motion that runs behind it would be over
// before anyone sees it, so scripts that animate things wait for it with this.
export default function whenPageShown(callback) {
    const loader = document.querySelector('.preloader-wrapper');
    if (!loader || 'none' === window.getComputedStyle(loader).display) {
        callback();

        return;
    }
    const timer = window.setInterval(() => {
        if ('none' === window.getComputedStyle(loader).display) {
            window.clearInterval(timer);
            callback();
        }
    }, 100);
}
